(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrWorkOrderTypeDetailController', TrWorkOrderTypeDetailController);

    TrWorkOrderTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrWorkOrderType', 'User'];

    function TrWorkOrderTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, TrWorkOrderType, User) {
        var vm = this;

        vm.trWorkOrderType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:trWorkOrderTypeUpdate', function(event, result) {
            vm.trWorkOrderType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
